import React from "react";
import "./InProgress.css";

const InProgress = () => {
  return (
    <div>
      <h1>Operations In Progress:</h1>
    </div>
  );
};

export default InProgress;
